module.exports = __webpack_public_path__ + "media/application_histories/icon_paper_airplane-cd8c8777.svg";